import React, { useState } from "react";
import ScriptSelector from "./ScriptSelector";

type TabId = "editor" | "chat";

const EditorToggle = ({
  activeTab,
  setActiveTab,
  hasChanges,
  onScriptChange,
  editorRef,
}: {
  activeTab: TabId;
  setActiveTab: (tab: TabId) => void;
  hasChanges: boolean;
  onScriptChange: (script: string) => void;
  editorRef: React.RefObject<any>;
}) => {
  return (
    <div className="relative border-b border-gray-100 px-6 py-3 items-center justify-between flex ">
      <div className="flex gap-4">
        <button
          onClick={() => setActiveTab("editor")}
          className={`relative rounded  font-medium transition-colors z-10 hover:cursor-pointer ${
            activeTab === "editor"
              ? "text-neutral-900"
              : "text-neutral-500 hover:text-neutral-700"
          }`}
        >
          Editor
        </button>
        {/* <button
           disabled
          onClick={() => setActiveTab("chat")}
          className={`relative   rounded  font-medium transition-colors z-10 hover:cursor-pointer ${
            activeTab === "chat"
              ? "text-neutral-900"
              : "text-neutral-500 hover:text-neutral-700"
          }`}
        >
          Chat
        </button> */}
      </div>
      {activeTab === "editor" && (
        <ScriptSelector
          hasChanges={hasChanges}
          onScriptChange={onScriptChange}
          editorRef={editorRef}
        />
      )}
    </div>
  );
};

export default EditorToggle;
